import apiClient from '@/Services/Clients/apiClient';
import DiscussionMessageModel from '@/Models/discussionMessageModel';

const DISCUSSION_BASE_URL = 'api/discussion';
class DiscussionService {

  public static getMessagesByRequestId = async (requestId: string): Promise<DiscussionMessageModel[]> => {
    const resourceUrl = `${DISCUSSION_BASE_URL}/request/${requestId}`;
    const serverDiscussionMessages = await apiClient.get(resourceUrl);
    const messages = DiscussionService.createDiscussionMessageModels(serverDiscussionMessages);

    return messages;
  };

  public static getMessagesByResponseId = async (responseId: string): Promise<DiscussionMessageModel[]> => {
    const resourceUrl = `${DISCUSSION_BASE_URL}/response/${responseId}`;
    const serverDiscussionMessages = await apiClient.get(resourceUrl);
    const messages = DiscussionService.createDiscussionMessageModels(serverDiscussionMessages);

    return messages;
  };

  /**
     * Sends a new discussion to the server to process. Returns an array of "DiscussionMessageModel"
     * containing the latest version of the discussion messages.
     * @param {string} requestId
     * @param {string} message
     * @return {Promise<DiscussionMessageModel[]>}
     */
  public static sendMessageForRequest = async (requestId: string, message: string): Promise<DiscussionMessageModel[]> => {
    const newMessageData = {
      parentItemId: requestId,
      content: message
    };

    // First send the new message to the server
    await apiClient.post(`${DISCUSSION_BASE_URL}/request`, newMessageData);

    // Then get all the discussion messages so all new ones are displayed
    return await DiscussionService.getMessagesByRequestId(requestId);
  };

  public static sendMessageForResponse = async (responseId: string, message: string): Promise<DiscussionMessageModel[]> => {
    const newMessageData = {
      parentItemId: responseId,
      content: message
    };

    // First send the new message to the server
    await apiClient.post(`${DISCUSSION_BASE_URL}/response`, newMessageData);

    // Then get all the discussion messages so all new ones are displayed
    return await DiscussionService.getMessagesByResponseId(responseId);
  };

  private static createDiscussionMessageModels(serverDiscussionMessages: any[]): DiscussionMessageModel[] {
    return serverDiscussionMessages.map(serverDiscussionMessage =>
      new DiscussionMessageModel(
        serverDiscussionMessage.messageId,
        serverDiscussionMessage.senderDisplayName,
        serverDiscussionMessage.content,
        serverDiscussionMessage.isLocalSender,
        serverDiscussionMessage.sentTimestamp,
        serverDiscussionMessage.acknowledgedTimestamp
      )
    );
  }
}
export default DiscussionService;
